import { render, staticRenderFns } from "./ModelSuggestionMenu.vue?vue&type=template&id=41b25a01&scoped=true"
import script from "./ModelSuggestionMenu.vue?vue&type=script&lang=ts"
export * from "./ModelSuggestionMenu.vue?vue&type=script&lang=ts"
import style0 from "./ModelSuggestionMenu.vue?vue&type=style&index=0&id=41b25a01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b25a01",
  null
  
)

export default component.exports